import {
  InteractHasNotificationActiveIcon,
  InteractHasNotificationIcon,
  InteractNotificationActiveIcon,
  InteractNotificationIcon,
} from '@/client/assets';
import { AuthedButton } from '@/client/components/authed-button';
import { useNotificationStatus } from '@/client/hooks/use-notification-status';
import { useSignedUserInfo } from '@/client/hooks/use-signed-user-info';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';

export const AsideNotification = () => {
  const { t } = useTranslation();
  const [location, navigate] = useLocation();
  const signedUser = useSignedUserInfo(api);
  const { hasNewNotification } = useNotificationStatus(api);
  const link = useMemo(() => `/user/${signedUser.data?.uid}/notification`, [signedUser.data?.uid]);
  const isActive = location.toLowerCase().startsWith(link.toLowerCase());
  return (
    <AuthedButton
      showAuth={false}
      showLoading={false}
      onClick={() => navigate(link)}
      variant="ghost"
      className={cn(
        'w-full flex items-center justify-start md:justify-center w-full h-12 leading-5 font-medium px-3 hover:bg-foreground/5',
        isActive ? 'bg-foreground/5 font-bold' : ''
      )}
    >
      {!hasNewNotification ? (
        isActive ? (
          <InteractNotificationActiveIcon className="!size-4.5 fill-foreground" />
        ) : (
          <InteractNotificationIcon className="!size-4.5 fill-foreground" />
        )
      ) : null}
      {hasNewNotification ? (
        isActive ? (
          <InteractHasNotificationActiveIcon className="!size-4.5 fill-foreground" />
        ) : (
          <InteractHasNotificationIcon className="!size-4.5 fill-foreground" />
        )
      ) : null}

      <span className="flex-1 text-start font-medium text-sm md:hidden">{t('routes.notification')}</span>
    </AuthedButton>
  );
};
